import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getMemberList(state) {
    return state.data
  },
}

export const mutations = {
  SET_MEMBER_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_MEMBER_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_MEMBER_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_MEMBER_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingMemberList({ commit }, params) {
    commit('SET_MEMBER_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/member/list/',
        payload: { ...params },
      })
      commit('SET_MEMBER_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_MEMBER_LIST_RECEIVED', error)
    }
  },
  resetMemberList({ commit }) {
    commit('RESET_MEMBER_LIST')
  },
  async deleteMemberById({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/member/unbind/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
  async exportMemberCsv({ commit }, params) {
    try {
      const response = await request({
        endpoint: '/cms/member/export/',
        payload: { ...params },
      })
      return response
    } catch (error) {
      return error
    }
  },
}
